import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/statistics/Inquiry/inquiryRanking",{
        params:params
    } )
}

function EXPORT(params) {
    return  axios.get("/statistics/Inquiry/inquiryRankingExport",{
        params: {
            ...params
        }
    }  )
}

export default {
    GET_LIST,
    EXPORT,
};
